<div class="d-flex flex-column gap-3" data-testid="notes-panel">
  <div class="d-flex flex-wrap align-items-start justify-content-between gap-3">
    <div class="d-flex flex-column gap-1">
      <h3 class="av-section-title m-0">{{ 'backoffice.organizations.notes.title' | translate }}</h3>
      <p class="av-meta m-0">{{ 'backoffice.organizations.notes.hint' | translate }}</p>
    </div>

    @if (facade.canWriteNotes()) {
      <button
        type="button"
        class="av-btn av-btn-primary"
        [disabled]="facade.isMutating()"
        (click)="openCreate()"
      >
        <mat-icon aria-hidden="true">add</mat-icon>
        {{ 'backoffice.organizations.notes.add' | translate }}
      </button>
    }
  </div>

  @if (!facade.canWriteNotes()) {
    <p class="av-meta m-0" data-testid="notes-restricted">{{ 'backoffice.organizations.notes.restricted' | translate }}</p>
  }

  @if (isEmpty()) {
    <av-empty-state
      icon="sticky_note_2"
      [title]="'backoffice.organizations.notes.empty.title' | translate"
      [message]="'backoffice.organizations.notes.empty.message' | translate"
    ></av-empty-state>
  } @else {
    <ul class="note-list d-flex flex-column gap-2 m-0 p-0">
      @for (note of facade.notes(); track note.id) {
        <li class="note-item p-3 d-flex flex-column gap-2">
          <div class="d-flex flex-wrap align-items-center justify-content-between gap-2">
            <div class="d-flex align-items-center gap-2">
              @if (note.pinned) {
                <mat-icon class="pin-icon" aria-hidden="true">push_pin</mat-icon>
              }
              <span class="cell-strong">{{ note.authorName }}</span>
              <span class="av-meta">
                {{ note.created_at ? (note.created_at | date: dateTimeFormat) : unresolved }}
              </span>
              @if (note.isEdited) {
                <span class="av-meta">{{ 'backoffice.organizations.notes.edited' | translate }}</span>
              }
            </div>

            @if (canManage(note)) {
              <div class="d-flex gap-1">
                <button
                  type="button"
                  class="av-btn"
                  [matTooltip]="'backoffice.organizations.notes.pin' | translate"
                  [disabled]="facade.isMutating()"
                  (click)="togglePinned(note)"
                >
                  <mat-icon aria-hidden="true">push_pin</mat-icon>
                </button>

                <button
                  type="button"
                  class="av-btn"
                  [matTooltip]="'backoffice.common.actions.edit' | translate"
                  [disabled]="facade.isMutating()"
                  (click)="openEdit(note)"
                >
                  <mat-icon aria-hidden="true">edit</mat-icon>
                </button>

                <button
                  type="button"
                  class="av-btn av-btn-danger"
                  [matTooltip]="'backoffice.organizations.notes.delete_confirm' | translate"
                  [disabled]="facade.isMutating()"
                  (click)="remove(note)"
                >
                  <mat-icon aria-hidden="true">delete</mat-icon>
                </button>
              </div>
            }
          </div>

          <p class="note-body m-0">{{ note.body }}</p>
        </li>
      }
    </ul>
  }
</div>
